/* @flow */
export const PAYMENT_TYPES = {
  INCLUDE: '送料込み（出品者が負担）',
  ARRIVAL: '着払い（落札者負担）',
};
